(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerDetailGallery', {
            templateUrl: 'app/admin/flyers/flyer-detail/details-panel/pictures/gallery/flyer-detail-gallery.html',
            controller: flyerDetailPicturesController,
            bindings: {
                flyer: '<',
                flyerImages: '<'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function flyerDetailPicturesController($rootScope, systemConstants) {
        var vm = this;
        vm.flyerImagePaths = [];

        vm.$onInit = init;

        function init() {
            if (vm.flyerImages && vm.flyerImages.length > 0) {
                vm.flyerImages.forEach(function (flyerImage) {
                    vm.flyerImagePaths.push({
                        id: flyerImage.id,
                        position: flyerImage.position,
                        path: getFlyerImageWithResolution(vm.flyer,
                            systemConstants.IMAGE_RESOLUTIONS.DETAILS_GALLERY, vm.flyerImages.indexOf(flyerImage))});
                })
            }
        }
    }
})();
